export default "__VITE_ASSET__CkTf_gWQ__"